import { Observable } from 'rxjs'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'

export abstract class UserTypeGateway {
    abstract getAllUserType(): Observable<ValidatedSelectOptionModel[]>

    abstract getAllOrganization(): Observable<ValidatedSelectOptionModel[]>

    abstract getAllUserProfileStatus(retrieveAll: boolean): Observable<ValidatedSelectOptionModel[]>

    abstract getAllStatusReasons(listID: number): Observable<ValidatedSelectOptionModel[]>
    abstract getFMO(): Observable<ValidatedSelectOptionModel[]>

    abstract getUserBasedRole(): Observable<ValidatedSelectOptionModel[]>
}
